<script lang="ts">
	import Tooltip, { Wrapper, Content } from '@smui/tooltip';

	export let title;
	export let inCard = false;
	export let icon = '';
	export let iconText = '';
</script>

<div>
	<h3
		class="m-0 ml-2.5 inline-flex font-semibold sm:font-bold {inCard
			? 'text-xl sm:text-2xl'
			: 'text-3xl sm:text-4xl'} normal-case leading-10 tracking-normal antialiased xl:leading-none"
	>
		{title}
		<div>
			<Wrapper rich>
				<span class="material-icons-outlined">{icon}</span>
				<Tooltip>
					<Content>
						{iconText}
					</Content>
				</Tooltip>
			</Wrapper>
		</div>
	</h3>
	<h2 class="m-0 ml-1.5 text-5xl leading-3 text-mobilityPlatform-green">—</h2>
</div>
